<template>
	<form-field :label="label" :error="error" :require="require">
		<prime-dropdown v-bind="$attrs">
			<template #indicator>
				<app-icon name="chevronDown" :size="18" :stroke-width="2" />
			</template>
		</prime-dropdown>
	</form-field>
</template>

<script setup>
import FormField from '@/components/Form/Field.vue';
import PrimeDropdown from 'primevue/dropdown';

defineProps({
	label: String,
	error: Object,
	require: Boolean,
});
</script>

<script>
export default {
	name: 'InputDropdown',
	inheritAttrs: false,
};
</script>
